
import {
    Match,
    SingleEliminationBracket,
    createTheme,
    SVGViewer
} from "@g-loot/react-tournament-brackets";
import { useEffect, useState } from "react";
import { formatDate } from "../utils/helper";

const BracketComponent = ({ datas }) => {
    const { width, height } = useWindowSize();
    const [thirdPlaceMatch, setThirdPlaceMatch] = useState(null)
    const finalWidth = Math.max(width - 50, 500);
    const finalHeight = Math.max(height - 170, 500);

    const [matches, setMatches] = useState([])
    const theme = createTheme({
        textColor: {
            main: "#fff",
            highlighted: "#fff",
            dark: "#fff",
        },
        matchBackground: { wonColor: "rgb(34 197 94 / 1)", lostColor: "#2B2B3D" },
        score: {
            background: { wonColor: "rgb(34 197 94 / 1)", lostColor: "#181829" },
            text: {
                highlightedWonColor: "#fff",
                highlightedLostColor: "#fff",
            },
        },
        roundHeader: { backgroundColor: '#09383d', fontColor: '#FFF' },
        svgBackground: "#000"
    });

    useEffect(() => {
        const matchesTemp = Object.entries(datas).map(
            ([id, match]) => ({ id, ...match })
        );
        const formatedDataMatches = matchesTemp.map(match => {
            return {
                ...match,
                id: parseInt(match.id),
                startTime: match.startTime + ' WIB',
                nextMatchId: parseInt(match.nextMatchId),
                participants: Object.entries(match.participants).map(
                    ([_, data]) => ({ ...data, id: data.name })
                ),
            }
        })
        const thirdPlaceTemp = formatedDataMatches.filter(match => {
            return match.id == 2
        })[0]
        setThirdPlaceMatch(thirdPlaceTemp)
        setMatches(formatedDataMatches)
    }, [datas])


    return (
        <div className="flex items-center">
            {matches.length > 0 && (
                <SingleEliminationBracket
                    matches={matches}
                    theme={theme}
                    options={{
                        style: {
                            roundHeader: {
                                backgroundColor: theme.roundHeader.backgroundColor,
                                fontColor: theme.roundHeader.fontColor,
                                border: "1px solid white"
                            },
                            connectorColor: '#e5e7eb',
                            connectorColorHighlight: theme.connectorColorHighlight,
                        },
                    }}
                    matchComponent={({
                        match,
                        topParty,
                        bottomParty,
                        teamNameFallback,
                    }) => (
                        <>
                            <div className="flex w-full h-full flex-col text-[#e5e7eb]">
                                <div className="flex justify-between">
                                    <div className="text-[#fff] font-bold">
                                        {match.startTime}
                                    </div>
                                    <div>

                                        {match.state === 'LIVE' ?
                                            <div className="text-red-600 flex items-center">

                                                <span className="rounded-full mr-2 bg-red-600 live-icon" />
                                                <div className="font-bold">
                                                    {match.state}
                                                </div>
                                            </div>
                                            : match.state === 'DONE' ?
                                                <div className="text-[#179b24] font-bold">
                                                    Final Score
                                                </div> : ''}
                                    </div>
                                </div>
                                <div className="border-2 rounded-lg">
                                    <div className="flex border-b-2">
                                        <div className={`w-9/12 border-r-2 p-2 bg-[#09383d] `}>
                                            {topParty.name || teamNameFallback}
                                        </div>
                                        <div className={`w-3/12 p-2 text-center bg-[#2897A3] ${topParty.isWinner ? 'bg-[#fc982d] text-[#e5e7eb]' : ''}`}>
                                            {topParty.resultText || <span style={{ color: '#e5e7eb' }}>0</span>}
                                        </div>
                                    </div>
                                    <div className="flex">
                                        <div className={`w-9/12 border-r-2 p-2 bg-[#09383d] `}>
                                            {bottomParty.name || teamNameFallback}
                                        </div>
                                        <div className={`w-3/12 p-2 text-center bg-[#2897A3] ${bottomParty.isWinner ? 'bg-[#fc982d]' : ''}`}>
                                            {bottomParty.resultText || <span style={{ color: '#e5e7eb' }}>0</span>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>

                    )}
                // svgWrapper={({ children, ...props }) => (
                //     <SVGViewer width={finalWidth} height={finalHeight} {...props} background={"#000"} svgBackground={"#000"}>
                //         {children}
                //     </SVGViewer>
                // )}
                />
            )}
            <div style={{ minWidth: '300px' }}>
                <div className="text-white font-bold">Perebutan Juara 3</div>
                {
                    thirdPlaceMatch ?
                        <div className="flex w-full h-full flex-col text-[#e5e7eb]">
                            <div className="flex justify-between">
                                <div className="text-[#fff] font-bold">
                                    {thirdPlaceMatch.startTime}
                                </div>
                                <div>

                                    {thirdPlaceMatch.state === 'LIVE' ?
                                        <div className="text-red-600 flex items-center">

                                            <span className="rounded-full mr-2 bg-red-600 live-icon" />
                                            <div className="font-bold">
                                                {thirdPlaceMatch.state}
                                            </div>
                                        </div>
                                        : thirdPlaceMatch.state === 'DONE' ?
                                            <div className="text-[#179b24] font-bold">
                                                Final Score
                                            </div> : ''}
                                </div>
                            </div>
                            <div className="border-2 rounded-lg">
                                <div className="flex border-b-2">
                                    <div className={`w-9/12 border-r-2 p-2 bg-[#09383d] `}>
                                        {thirdPlaceMatch?.participants?.[0].name}
                                    </div>
                                    <div className={`w-3/12 p-2 text-center bg-[#2897A3] ${thirdPlaceMatch?.participants?.[0].isWinner ? 'bg-[#fc982d] text-[#e5e7eb]' : ''}`}>
                                        {thirdPlaceMatch?.participants?.[0].resultText || <span style={{ color: '#e5e7eb' }}>0</span>}
                                    </div>
                                </div>
                                <div className="flex">
                                    <div className={`w-9/12 border-r-2 p-2 bg-[#09383d] `}>
                                        {thirdPlaceMatch?.participants?.[1].name}
                                    </div>
                                    <div className={`w-3/12 p-2 text-center bg-[#2897A3] ${thirdPlaceMatch?.participants?.[1].isWinner ? 'bg-[#fc982d]' : ''}`}>
                                        {thirdPlaceMatch?.participants?.[1].resultText || <span style={{ color: '#e5e7eb' }}>0</span>}
                                    </div>
                                </div>
                            </div>
                        </div> : ""
                }
            </div>
        </div>
    )
}



export default BracketComponent;

function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined,
    });
    useEffect(() => {
        // Handler to call on window resize
        function handleResize() {
            // Set window width/height to state
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        // Add event listener
        window.addEventListener("resize", handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
}